<template>
	<div class="job-wrap">
		<el-breadcrumb separator="/" class="path">
			<el-breadcrumb-item :to="{ path: '/' }" class="path-home">
				<i class="n el-icon-s-home"></i>
				首页
			</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/job' }">招聘求职</el-breadcrumb-item>
			<el-breadcrumb-item class="path-help">信息详情</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="news" v-loading="loading" >
			<div class="content">
				<div class="detail" v-if="detail">
					<div class="info">
						<div class="time">更新:{{detail.update_time||detail.create_time||'无'}}</div>
						<h1>{{detail.title}}</h1>
						<div class="salary">
							<!-- <span>薪资:</span> -->
							<p v-if="detail.salary>0">{{Math.round(detail.salary/1000)}}K</p>
							<p v-else>面谈</p>
						</div>
						<div class="o">
							<div>
								<span>城市:</span>
								<p>{{detail.area?detail.area.name:''}}</p>
							</div>
							<div>
								<span>招聘人数:</span>
								<p>{{detail.number||'无限制'}}</p>
							</div>
							<div>
								<span>地址:</span>
								<p>{{detail.address||'无'}}</p>
							</div>
							<div>
								<span>工作经验:</span>
								<p>{{workingList[detail.working]||'无'}}</p>
							</div>
							<div>
								<span>学历要求:</span>
								<p>{{educationList[detail.education]||'无'}}</p>
							</div>
						</div>
						
						<div class="seebox">
							<el-button type="primary"  round @click="see">申请职位</el-button>
						</div>
					</div>
					<div class="box">
						<div class="left">
							<sub-title title="具体需求"></sub-title>
							<div class="content" v-html="content()"></div>
							<div class="tips">
								以担保或任何理由索要财物,扣押证照,均涉嫌违法,请勿轻信
							</div>							
						</div>
						<div class="right">
							<sub-title title="职位发布者"></sub-title>
							<div class="title">
								<el-avatar :size="40" :src="detail.site.logo"></el-avatar>
								<h3>{{detail.site.site_name}}</h3>
							</div>
							<div class="con">
								{{detail.site.seo_description}}
							</div>
							<div class="l">
								<span>联系人:</span>
								<span>{{detail.contacts||detail.site.name||'暂无'}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="other">
				<job-recommend :num="9"></job-recommend>
			</div>
		</div>
	</div>
</template>

<script>
import {
	// newsCat,
	newsList,
	// jobDetail
} from "@/api/cms/news";
import {
	jobDetail
} from "@/api/cms/job";
import SubTitle from "@/components/SubTitle"
import DescText from "@/components/DescText"
import UsedRecommend from "../used/components/recommend"
import JobRecommend from "../job/components/recommend"
import {
	mapGetters
} from "vuex"

export default {
	name: 'job_detail',
	components: {
		// sidebar,
		SubTitle,
		// list1,
		// newsList1,
		JobRecommend
	},
	data: () => {
		return {
			id:null,
			loading: true,
			detail:null,
			workingList:[
				//0不限制 1在校生应届生 2 1-3年 3,3-5年,4,5-10年,5,10年以上
				'不限制',
				'在校生应届生',
				'1-3年',
				'3-5年',
				'5-10年',
				'10年以上',
			],
			educationList:[
				//0学历要求 默认0 |0不限制|1初中|2高中\中职\中专|3大专|4本科|5硕士|6博士
				'不限制',
				'初中',
				'高中\中职\中专',
				'大专',
				'本科',
				'硕士',
				'博士',
			],
			// newsList:[]
		};
	},
	created() {
		this.id = this.$route.params.pathMatch
		// this.id = this.$route.path.replace('/job-detail-', '');
		// console.log(1333333333333,this.id);
		this.getDetail();
		// this.getNewsList();
	},
	computed: {
		...mapGetters(["token", "defaultHeadImage",])
	},
	watch: {
		$route(curr) {
			this.id = curr.params.pathMatch;
			// console.log(22222);
			this.getDetail();
		}
	},
	methods: {
		getDetail() {
			jobDetail({
				id: this.id
			}).then(res => {
				if (res.code == 0) {
					if (res.data) {
						this.loading = false;
						this.detail = res.data;
					} else {
						this.$router.push({ path: '/404' });
					}
				}
			}).catch(err => {
				this.loading = false;
				this.$message.error(err.message);
			});
		},
		getNewsList() {
			newsList({
				// id: this.id
				// page:
			}).then(res => {
				if (res.code == 0 && res.data) {
						// this.loading = false;
					this.newsList = res.data.list;
				} else {
					// console.log(333)
					// this.$router.push({ path: '/cms/help' });
				}
			}).catch(err => {
				// this.loading = false;
				this.$message.error(err.message);
			});
		},
		contacts(row){
			let str  = (row.tel || row.phone || row.email || row.site.telephone || row.site.mobile || row.site.email || '')
			if(str){
				return str.substr(0,3)+"****"+str.substr(7);
			}
			return '暂无';
		},
		see(){
			if(this.token){
				let c = this.detail.contacts|| this.detail.site.name || '暂无';
				let str  = (this.detail.tel || this.detail.phone || this.detail.email || this.detail.site.telephone || this.detail.site.mobile || this.detail.site.email || '')
				this.$alert(`联系人:${c},联系方式:${str}`,'联系我时请提醒我从'+this.$config.title+'看到',  {
					confirmButtonText: '好的',
				});
			}else{
				this.$alert(`请登录查看`,'联系我时请提醒我从'+this.$config.title+'看到',  {
					confirmButtonText: '好的',
					// callback: action => {}
				});
			}
		},
		content(){
			let c = this.detail.content || '';
			c= c.replace(/<img[^>]*>/gi,function(match,capture){
				match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
				match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
				match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
				return match;
			});
			// console.log(111,c)
			// newContent = newContent.replace(/\<img[^>]*>/gi, '2222222222222');
//         	newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
//         		match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
//         		return match;
//         	});
			
        	c = c.replace(/<br[^>]*\/>/gi, '<br>');
//         	newContent = newContent.replace(/\<img[^>]*>/gi, '');
			// console.log(1211,c)
        	c = c.replace(/<p[^>]*>/gi,'<p>')
			// console.log(133311,c)
			// newContent = newContent.replace(/(<([^>]+)>)/ig, '');
			// c = c.replace(/\s+/g,"");
			// console.log(4111,c)
			return c;
			// ()detail.content
		}
	}
};
</script>
<style lang="scss" scoped>
.job-wrap {
	background: #ffffff;
	.path {
		padding: 15px 0;
	}
}
	
.news {
	padding-bottom: 20px;
	.content{
		// display: flex;
		// flex-flow: wrap;
		width: 1210px;
		margin-bottom: 20px;
		.detail{
			display: block;
			overflow: hidden;
			.account{
				// margin:  0 0 0 ;
				text-align: right;
				span{
					margin:0  10px;
				}
			}
			.info{
				background-color: #F5FAFF;//#f8f8f8;
				color:#000;
				border-top-left-radius: 25px;
				border-bottom-right-radius: 25px;
				position: relative;
				padding: 25px;
				// border: 2px solid $base-color;
				margin:  15px 0;
				.time{
					display: block;
				}
				h1{
					// text-align: center;
					// line-height: 60px;
					font-size: 24px;
				}
				.salary{
					font-size: 20px;
					color: $base-color;
				}
				.o{
					margin-bottom: 15px;
					div{
						float: left;
						width: auto;
						padding-right: 15px;
						display: flex;
						span{
							width: auto;
						}
						p{
							flex:1;
						}
					}
				}
				
				.seebox{
					position: absolute;
					top: 30px;
					right: 100px;
					width: 300px;
					z-index: 99;
					// background-color: #fff;
					// color: #000;
					padding: 15px;
					border-top-left-radius: 25px;
					border-bottom-right-radius: 25px;
					// .con{
					
					// 	height: 175px;
					// }
					.el-button{
						float: right;
					}
				}
			}
			.box{
				display: flex;
				.left{
					flex:1;
					padding-right: 50px;
					.content{
						margin: 15px 0 0 0 ;
						display: block;
						overflow: hidden;
						width: 100%;
					}
					.tips{
						background-color: #ffe8a4;
						padding: 10px 15px;
					}
				}
				.right{
					width: 300px;//900px;
					// background-color: #ccc;
					padding: 0 15px;
					border: 1px solid #eee;
					.title{
						display: flex;
						h3{
							flex:1;
							line-height: 40px;
							padding-left: 10px;
						}
					}
					.con{
						margin-top: 10px;
						// display: block;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 7;
						overflow: hidden;
						text-indent: 2em;
						text-align: justify;
					}
					.l{
						float: right;
					}
				}
			}
		}
		
		.other{
			display: block;
		}
		// .right-column{
		// 	// width: 260px;
		// 	flex: 1;
		// 	padding-left: 20px;
		// 	overflow: hidden;
		// }
	}
}
</style>
